/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/video-logged-out-page';

type Props = {
  skills: Array<string>;
};

const styles = {
  wrapper: css`
    .skills-title {
      font-weight: bold;
    }

    .skills-list {
      justify-content: flex-start;
    }
  `,
};

export default function CourseSkills({ skills = [] }: Props) {
  if (skills.length < 2) return null;

  return (
    <div className="rc-CourseSkills vlp-container-section" css={styles.wrapper}>
      <Typography2 component="h3" variant="subtitleMedium" className="skills-title">
        {_t("Skills You'll Learn")}
      </Typography2>
      <Typography2 component="p" variant="bodyPrimary" data-e2e="skills-list" className="skills-list">
        {skills.join(', ')}
      </Typography2>
    </div>
  );
}
